import * as signalR from '@aspnet/signalr';

const signalRConnection = new signalR.HubConnectionBuilder()
  .withUrl(process.env.VUE_APP_HUB_ROOT + '/streamhub')
  // .configureLogging(signalR.LogLevel.Critical) // TODO uncomment this in prod so all reconnects aren't logged
  .build();

signalRConnection.keepAliveIntervalInMilliseconds = 1000 * 60 * 60; // Three minutes
signalRConnection.serverTimeoutInMilliseconds = 1000 * 60 * 60; // Six minutes

let reconnectTimeoutId: ReturnType<typeof setTimeout> | null = null;
let reconnectAttempts = 0;
const MAX_RECONNECT_DELAY_MS = 60000;
const BASE_RECONNECT_DELAY_MS = 5000;

async function connect(conn: any) {
  // Cancel any pending retry so we don't stack timeouts.
  if (reconnectTimeoutId !== null) {
    clearTimeout(reconnectTimeoutId);
    reconnectTimeoutId = null;
  }

  conn
    .start()
    .then(() => {
      reconnectAttempts = 0; // Reset on successful connect.
    })
    .catch((e: any) => {
      console.error(e);
      const delay = Math.min(
        BASE_RECONNECT_DELAY_MS * Math.pow(2, reconnectAttempts),
        MAX_RECONNECT_DELAY_MS
      );
      reconnectAttempts++;
      reconnectTimeoutId = setTimeout(() => {
        reconnectTimeoutId = null;
        connect(conn);
      }, delay);
    });
}

signalRConnection.onclose((err: any) => {
  connect(signalRConnection);
});

let initialized = false;

export default {
  init() {
    // Prevent duplicate connect calls on re-init.
    if (initialized) {
      return;
    }
    initialized = true;
    connect(signalRConnection);
  },
  getConnection() {
    return signalRConnection;
  },
};
